<template>
	<div>
<!--		<breadcrumb :routerList="[{title:'OEM付款报表 '}]"/>-->
    <Breadtabsheader/>
		<div class="h-content">
			<div class="h-piece">
				<div class="h-formBox">
					<el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="销售单号" style="width: 50%;">
								<el-input v-model="q.orderCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
							</el-form-item>
							<el-form-item label="发票日期" style="width: 50%;">
								<el-date-picker
										placeholder="请选择"
										v-model="q.fcdatebegin"
										clearable
										type="date"
										value-format="yyyy-MM-dd" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
										placeholder="请选择"
										v-model="q.fcdateend"
										clearable
										type="date"
										value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="订单状态">
										<brselect category="cg_status" v-model="q.status" :v="q.status" :clearable="true"></brselect>
									</el-form-item>
									<el-form-item label="采购单号">
										<el-input v-model="q.code" placeholder="请输入" ></el-input>
									</el-form-item>
									<el-form-item label="创建时间" style="width: 50%;">
										<el-date-picker
												placeholder="请选择"
												v-model="q.cdatebegin"
												clearable
												type="date"
												value-format="yyyy-MM-dd" >
										</el-date-picker>
										<span class="w-time-to">至</span>
										<el-date-picker
												placeholder="请选择"
												v-model="q.cdateend"
												clearable
												type="date"
												value-format="yyyy-MM-dd" >
										</el-date-picker>
									</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="发票号">
										<el-input v-model="q.invoiceno" placeholder="请输入" ></el-input>
									</el-form-item>
									<el-form-item label="DN单号">
										<el-input v-model="q.add3" placeholder="请输入"></el-input>
									</el-form-item>
									<el-form-item label="　供应商名称">
										<el-input v-model="q.suserName" placeholder="请输入"></el-input>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>

						<!-- <div class="h-formBtnOut h-columnCenter">
						    <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
						    <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						</div> -->
					</el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="query">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						</div>
					</div>
				</div>
			</div>


			<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible4" width="38%" class="body_dilog ljjdiolog" title="发票详情">
				<div class="h-rowIn" >
					<div class="h-rowBox">
						<div class="h-rowCon" style="padding-bottom: 0.8rem;">

							<el-table
									ref="multipleTable"
									:data="tableData4"
									stripe
									style="width: 100%"
									:border="true"
									max-height="220"
							>
								<el-table-column
										prop="invoiceNo"
										:show-overflow-tooltip="true"
										label="发票号">
								</el-table-column>
								<el-table-column
										prop="invoiceDate"
										:show-overflow-tooltip="true"
										label="发票日期">
								</el-table-column>
								<el-table-column
										prop="fpje"
										:show-overflow-tooltip="true"
										label="发票金额">
								</el-table-column>
								<el-table-column
										label="附件"
										width="180"
								>
									<template slot-scope="scope">
										<brupload
												:refid=scope.row.invoiceNo
												reftype="发票维护附件"
												:showtime="false"
										>
										</brupload>
									</template>
								</el-table-column>
							</el-table>

						</div>
					</div>
				</div>
			</el-dialog>

			<div class="h-row purchaselist">
				<div class="h-rowIn" style="width:100%;">
					<el-table
							ref="multipleTable"
							@selection-change="handleSelectionChange"
							:data="tableData"
							:span-method="objectSpanMethod"
							stripe
							:row-style="cellstyle"
							style="width: 100%"
							border
							max-height="450"
					>
						<el-table-column
								type="index"
								width="40"
								label="#"
								fixed
						>
						</el-table-column>
						<el-table-column
								prop="orderCode"
								label="销售单号"
								:show-overflow-tooltip="true"
								width="120"
								fixed
						>
						</el-table-column>
						<el-table-column
								prop="status"
								label="订单状态"
								:show-overflow-tooltip="true"
								width="90"
						>
							<template slot-scope="scope">
								<dictname category="cg_status"  :v="scope.row.status"/>
							</template>
						</el-table-column>
						<el-table-column
								prop="add3"
								label="DN单号"
								width="120"
								:show-overflow-tooltip="true"
						>
						</el-table-column>
						<el-table-column
								prop="productDes"
								label="物料型号"
								width="160"
								:show-overflow-tooltip="true"
						>
							<template scope="scope">
								<div style="text-align: left;">
									{{scope.row.productDes}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="productNo"
								label="物料编码"
								:show-overflow-tooltip="true"
								width="120">
						</el-table-column>
						<el-table-column
								prop="count"
								label="物料数量"
								:show-overflow-tooltip="true"
								width="90"
						>
							<template scope="scope">
								<div style="text-align: right;">
									{{scope.row.count}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="finalPrice"
								label="销售单价"
								width="90"
								:show-overflow-tooltip="true"
						>
							<template scope="scope">
								<div style="text-align: right;">
									{{scope.row.finalPrice}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="finaltotalprice"
								label="销售总价"
								width="90"
								:show-overflow-tooltip="true"
						>
							<template scope="scope">
								<div style="text-align: right;">
									{{scope.row.finaltotalprice}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="code"
								label="采购单号"
								:show-overflow-tooltip="true"
								width="110"
						>
						</el-table-column>
						<el-table-column
								prop="suserName"
								:show-overflow-tooltip="true"
								label="供应商"
								width="180"
						>
							<template scope="scope">
								<div style="text-align: left;">
									{{scope.row.suserName}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="unitPrice"
								label="采购单价"
								width="90"
								:show-overflow-tooltip="true"
						>
							<template scope="scope">
								<div style="text-align: right;">
									{{scope.row.unitPrice}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="totalPrice"
								label="采购总价"
								:show-overflow-tooltip="true"
								width="90">
							<template scope="scope">
								<div style="text-align: right;">
									{{scope.row.totalPrice}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="payAmount"
								label="已付款金额"
								width="110"
								:show-overflow-tooltip="true"
						>
							<template scope="scope">
								<div style="text-align: right;">
									{{scope.row.payAmount}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
								prop="cdate"
								label="下单时间"
								width="160"
								:show-overflow-tooltip="true"
						>
						</el-table-column>
						<!--<el-table-column-->
						<!--prop="invoiceno"-->
						<!--label="发票号"-->
						<!--width="160"-->
						<!--:show-overflow-tooltip="true"-->
						<!--&gt;-->
						<!--</el-table-column>-->
						<!--<el-table-column-->
						<!--prop="invoicedate"-->
						<!--label="发票日期"-->
						<!--width="110"-->
						<!--value-format="yyyy-MM-dd"-->
						<!--:show-overflow-tooltip="true"-->
						<!--&gt;-->
						<!--</el-table-column>-->
						<!--<el-table-column-->
						<!--label="附件"-->
						<!--width="180"-->
						<!--&gt;-->
						<!--<template slot-scope="scope">-->
						<!--<brupload-->
						<!--:refid=scope.row.invoiceno-->
						<!--reftype="发票维护附件"-->
						<!--:showtime="false"-->
						<!--&gt;-->
						<!--<el-button size="small" type="text">上传</el-button>-->
						<!--</brupload>-->
						<!--</template>-->
						<!--</el-table-column>-->
						<el-table-column
								label="操作"
								fixed="right"
								width="80"
						>
							<template slot-scope="scope">
								<div style="text-align: left;">
									<el-button
											type="text"
											size="small"
											@click="fapiaoXiangqing(scope.row.code)"
											class="h-tableLink h-btn">
										发票详情
									</el-button>
								</div>

							</template>
						</el-table-column>
					</el-table>

					<div class="h-tableB h-mrt30">
						<div class="h-tableBL">
							<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
						</div>
						<div class="h-pagination2">
							<pagination :page="q" @query="query"/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
    import ss from '../../api/SystemService'
    import util from "../../utils/util"
    import updownfile from '../../utils/updownfile'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
    export default {
        components: {
            uploaddownexcel,
        },
        data(){
            return{
                // 展开折叠筛选
                isScreen:false,
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                //导入Excel
                uploaddownexcelflag: false,
                dialogFormVisible4:false,
                tableData4:[],
                proSupplier:{},
                showFujian: false,
                //游标集
                spanArr:[],

                //游标定位
                position:'',
                checked:true,
                showOrhide:false,
                toshow:'purchaselist',
                status:1,
                names:'',
                input1:'',
                sele:'采购订单',
                options2:[],
                multipleSelection: [],
                //列表
                tableData: [],
                q: {
                    orderCode :'',
                    suserName :'',
                    status :'',
                    add3:'',
                    cdatebegin :'',
                    cdateend :'',
                    code :'',
                    fcdatebegin :'',
                    fcdateend: '',
                    invoiceno :'',
                    pageSize:10,
                    pageNo:1,
                    total:0
                },
            }
        },
        methods:{
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            cellstyle(value){
                //console.log(value)
                if(value.row.status == 0 || value.row.status == 1 || value.row.status == 2 || value.row.status == 3){
                    return 'font-weight: bold;'
                }
            },
            //记录游标的方法
            getSpanArr() {

                //游标集，每个元素的下标对应当前页table的每一行的行号，每个元素的数字对应这一行条件相同的共重复了几行
                this.spanArr = [];

                //遍历当前表元素
                this.tableData.forEach((item, index) => {

                    //当第一行时
                    if (index === 0) {

                        //默认先放第一行是1次
                        this.spanArr.push(1);

                        //记录当前重复行的位置
                        this.position = 0;

                        //其他行
                    } else {

                        //如果该行上的zhubiaoid与上一行上的zhubiaoid重复
                        if (this.tableData[index].zhubiaoid === this.tableData[index - 1].zhubiaoid) {

                            //从游标集中取到记录重复行的那行的重复数字，自增1(又重复一次)
                            this.spanArr[this.position] += 1;

                            //因为这次重复了，所以放入0记录作为这行实际上应该被合并掉
                            this.spanArr.push(0);

                            //若不重复
                        } else {

                            //继续向游标集放入一个1作为本行没有重复的独立一次记录
                            this.spanArr.push(1);

                            //记录重复行位置的游标移动到本行位置
                            this.position = index;

                        }
                    }
                })
            },

            //合并单元行方法
            objectSpanMethod({row, column, rowIndex, columnIndex}) {


                //需要合并单元行的是哪几列
                if (column.label=="采购主表id") {

                    //从游标集取到对应行下标位置的行重复记录数字，作为需要被合并多少行的rowspan数(该行跨了几行)
                    const _row = this.spanArr[rowIndex];

                    //该行跨了几列
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

            },
            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },

            fapiaoXiangqing(code) {
                this.dialogFormVisible4 =true;
                ss.orderCgService.selectInvoiceNoXinxiByCodeCg(code).then(rd => {
                    this.tableData4 = rd;
                    console.log(rd,"111111111111")
                });
            },
            //重置按钮功能
            resetData(){
                this.q.orderCode = null;
                this.q.suserName =null;
                this.q.status = null;
                this.q.add3 = null;
                this.q.cdatebegin = null;
                this.q.cdateend = null;
                this.q.code = null;
                this.q.fcdatebegin = null;
                this.q.fcdateend = null;
                this.q.invoiceno = null;
            },
            query() {
                ss.orderCgService.selectBackPage(this.q).then(rd =>{
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                });
            },
            //明细导出
            exportExcel() {

                var idlist=[];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.cgId);
                });
                if (idlist) {
                    this.q.ids = idlist.join(",");
                } else {
                    this.q.ids ='';

                }
                updownfile.down("/api/swyl/v1/dingd/bsc/OrderCg/backdownloadExcel",this.q,"post",'params');

            },
        },
        mounted() {
            this.query();
        }
    }
</script>
<style>
	.wuliu .h-dialogForm .h-elformWrap-2 .el-form-item__label{
		width: 27%;
	}
	.wuliu .h-formbLine .h-elformWrap-2{
		width: 100%!important;
	}
	.purchaselist	.h-tableLink{
		padding:0px!important;
	}
</style>
<style scoped lang="scss">
	.bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
	.leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;

		}
		.steps{
			position: absolute;
			z-index: 1;

		}
		.step1{
			top: 0.8rem;
			left: 0;
			width: 6rem;
			height: 11.5rem;
		}
		.step2{
			top: 1.63rem;
			right: 6.9rem;
			width: 9.4rem;
			height: 1.9rem;
		}
		.step3{
			width: 2.3rem;
			height: 1.9rem;
			right: 3.7rem;
			top: 1.6rem;
		}
		.step4{
			width: 3rem;
			height: 2.3rem;
			right: 0.7rem;
			top: 1.65rem;
		}
		.step5{
			width: 6.25rem;
			height: 1.3rem;
			right: 0.37rem;
			top: 4.25rem;
		}
		.step6{
			width: 3.9rem;
			height: 1.1rem;
			left: 2.6rem;
			top: 7.1rem;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.75rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
